// 0=Mon … 6=Sun — matches Python's date.weekday() used by the backend.
export const WEEKDAYS = [
  { value: 0, short: 'Mon', long: 'Monday' },
  { value: 1, short: 'Tue', long: 'Tuesday' },
  { value: 2, short: 'Wed', long: 'Wednesday' },
  { value: 3, short: 'Thu', long: 'Thursday' },
  { value: 4, short: 'Fri', long: 'Friday' },
  { value: 5, short: 'Sat', long: 'Saturday' },
  { value: 6, short: 'Sun', long: 'Sunday' },
];

export const NTH_OPTIONS = [
  { value: 1, label: 'First' },
  { value: 2, label: 'Second' },
  { value: 3, label: 'Third' },
  { value: 4, label: 'Fourth' },
  { value: -1, label: 'Last' },
];

export const RECURRENCE_TYPES = [
  { value: 'none', label: 'Does not repeat' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

export const blankRecurrence = () => ({ type: 'none', weekdays: [], nth: 1, weekday: 5 });

export const recurrenceFromEvent = (ev) => {
  const r = ev?.recurrence;
  if (!r) return blankRecurrence();
  return { ...blankRecurrence(), ...r };
};

// Shape the form state into the API payload (null for one-off events).
export const recurrenceToPayload = (r) => {
  if (!r || r.type === 'none') return null;
  if (r.type === 'daily') return { type: 'daily' };
  if (r.type === 'weekly') return { type: 'weekly', weekdays: r.weekdays };
  return { type: 'monthly', nth: r.nth, weekday: r.weekday };
};

export const formatEventDate = (iso, opts) => {
  if (!iso) return '';
  try {
    return new Date(iso + 'T00:00:00').toLocaleDateString('en-IN', opts || {
      weekday: 'short', day: 'numeric', month: 'short',
    });
  } catch (_) { return iso; }
};

export const timeLabel = (ev) => {
  if (ev.is_all_day) return 'All day';
  if (!ev.start_time) return '';
  return ev.end_time ? `${ev.start_time} – ${ev.end_time}` : ev.start_time;
};
